<template>
    <div>
        <app-layout>
            <template v-slot:header>
                <Header :title="$t('my_course_schedule')"
                        :isNewButton="checkPermission('dailycourseschedule_store')"
                        @new-button-click="createFormShow()"
                        :isFilter="false"/>
            </template>
            <template v-slot:header-mobile>
                <HeaderMobile :title="$t('my_course_schedule')"
                              :isNewButton="checkPermission('dailycourseschedule_store')"
                              @new-button-click="createFormShow()"
                              :isFilter="false"/>
            </template>
            <CommonModal ref="createFormModal" size="lg" :onHideOnlyX="true" @bHideModalHeaderClose="formClear">
                <template v-slot:CommonModalTitle>
                    {{ $t('new').toUpper() }}
                </template>
                <template v-slot:CommonModalContent>
                    <makeup-create :formId="formId" @createFormSuccess="createFormSuccess" v-if="formProcess == 'create'" />
                </template>
            </CommonModal>
        </app-layout>
    </div>
</template>
<script>
import AppLayout from '@/layouts/AppLayout'
import Header from '@/layouts/AppLayout/Header'
import HeaderMobile from '@/layouts/AppLayout/HeaderMobile'

import CommonModal from "@/components/elements/CommonModal";

// Services
import DailyCourseScheduleService from '@/services/DailyCourseScheduleService'
import MakeupCreate from "./MakeupCreate.vue";

export default {
    components: {
        AppLayout,
        Header,
        HeaderMobile,
        CommonModal,
        MakeupCreate,
    },
    data() {
        return {
            startDate: null,
            events: [],
            selectedEvent: {},
            semesterIsActive: true,
            formProcess: null,
            formId: null
        }
    },
    metaInfo() {
        return {
            title: this.$t('lesson_timetable')
        }
    },
    methods: {
        createFormShow() {
            this.formProcess = 'create'
            this.$refs.createFormModal.$refs.commonModal.show()
        },
        createFormSuccess() {
            this.$refs.createFormModal.$refs.commonModal.hide()
        },
        getData() {
           /* if(this.semesterIsActive){
                DailyCourseScheduleService.get(this.id)
                    .then(response => {
                        response.data.data.forEach(item => {
                            this.events.push({
                                start: moment(this.startDate, 'YYYY-MM-DD').add(item.day - 1, 'days').format('YYYY-MM-DD') + ' ' + item.start_time,
                                end: moment(this.startDate, 'YYYY-MM-DD').add(item.day - 1, 'days').format('YYYY-MM-DD') + ' ' + item.end_time,
                                title: this.getLocaleText(item, 'classroom_name'),
                                content: this.getLocaleText(item, 'course_name') + ' (' + item.course_code + ')' + '<br>' + this.$t('section') + ': ' + item.section
                            })
                        })
                    })
                    .catch(e => {
                        this.showErrors(e)
                    })
            }*/
        },

    /*    showVueCalModal(event, e){
            this.selectedEvent = event
            moment.locale('tr')
            this.selectedEvent.date = moment(event.start).format("DD-MM-YYYY")
            this.selectedEvent.start_time = moment(event.start).format("LT")
            this.selectedEvent.end_time = moment(event.end).format("LT")
            this.$refs.vueCalModal.$refs.commonModal.show()
            e.stopPropagation()
        },*/
    },

    created() {
        // this.startDate = moment().startOf('week').add(+1, 'days').format('YYYY-MM-DD');
        this.formId = this.$route.params.id
        this.getData()
    }
}
</script>
